<template>
  <div>
    <form-field-datetime-picker
      v-if="!hideInput"
      :label="isPastNextContactAt ? nextContactAtLabel + ' (Past Due)' : nextContactAtLabel"
      v-model="nextContactValue"
      :is-error="isPastNextContactAt"
      :is-inline="isInlineCalendar"
      :append-to-body="appendCalendarToBody"
      is-clearable
    >
      <template v-slot:after>
        <div :class="['flex', {'flex-vertical-reverse': isInlineCalendar}]">
          <button-outlined
            :class="{'mx-50': !isInlineCalendar, 'is-fullwidth': isInlineCalendar}"
            @click="saveNextContactAt"
            :disabled="isSaveButtonDisabled"
            :loading="savingContact"
          >Save
          </button-outlined>


          <button-outlined
            v-if="isInlineCalendar"
            class="mb-100 w-full"
            @click="cancelNextContactAt"
            :disabled="isCancelButtonDisabled"
          >Cancel
          </button-outlined>

          <button-link
            v-else
            @click="cancelNextContactAt"
            :disabled="isCancelButtonDisabled"
          >Cancel
          </button-link>
        </div>
      </template>
    </form-field-datetime-picker>

    <template v-else>
      <p v-if="record.next_contact_at" class="mb-25">{{ nextContactAtLabel }}: {{ nextContactFormatted }}</p>
      <p v-else class="mb-25">{{ nextContactAtLabel }}: <em>not set</em></p>
    </template>

    <div :class="['flex', removeFlexBetween ? 'flex-vertical-center' : 'flex-between']">
      <p v-if="hideInput" class="mr-25 is-size-7">Change to</p>
      <button-outlined
        v-if="!hideOneHour"
        @click="setNextContact(1)"
        color="is-secondary"
        is-short
      >One Hour
      </button-outlined>

      <button-outlined
        @click="setNextContact(24)"
        color="is-secondary"
        :class="{'ml-50': !hideOneHour}"
        is-short
      >Tomorrow
      </button-outlined>

      <button-outlined
        @click="setNextContact(24*7)"
        color="is-secondary"
        class="ml-50"
        is-short
      >Next Week
      </button-outlined>

      <button-outlined
        v-if="showNextMonth"
        @click="setNextContact(24*30)"
        color="is-secondary"
        class="ml-50"
        is-short
      >Thirty Days
      </button-outlined>
    </div>
  </div>
</template>

<script>
import {ENUMS} from "../../services/enums";
import dates from "../../services/dates";

export default {
  name: "RecordNextContact",
  props: {
    record: {
      type: Object,
      required: true
    },
    showNextMonth: {
      type: Boolean,
      default: false,
    },
    hideOneHour: {
      type: Boolean,
      default: false,
    },
    hideInput: {
      type: Boolean,
      default: false,
    },
    removeFlexBetween: {
      type: Boolean,
      default: false,
    },
    isInlineCalendar: {
      type: Boolean,
      default: false,
    },
    appendCalendarToBody: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      savingContact: false,
      nextContactValue: this.record.next_contact_at
    };
  },
  watch: {
    record: function() {
      this.nextContactValue = this.record.next_contact_at;
    },
  },
  computed: {
    isCreateNextContactAt() {
      return this.$store.getters.account.is_next_contact_at
    },
    isSaveButtonDisabled() {
      return this.nextContactValue === this.record.next_contact_at;
    },
    isCancelButtonDisabled() {
      return this.nextContactValue === this.record.next_contact_at;
    },
    nextContactFormatted() {
      if(this.record.next_contact_at) return dates.formatAsDate(this.record.next_contact_at);
      return null;
    },
    isPastNextContactAt() {
      if (this.nextContactValue) {
        const now = new Date();
        const nextContactAt = new Date(this.nextContactValue);

        return nextContactAt.getTime() <= now.getTime();
      }

      return false;
    },
    status() {
      return this.$store.getters['pipeline/getStatusById'](this.record.current_status_id);
    },
    nextContactAtLabel() {
      return "Next Contact At";
      // const followUp = ENUMS.StatusStateEnum.FollowUp.value;
      // return this.status.state === followUp ? "Next Follow Up" : "Next Contact At";
    }
  },
  methods: {
    setNextContact(hours) {
      let currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + hours);
      this.nextContactValue = currentDate;

      if(this.hideInput) {
        this.saveNextContactAt();
      }
    },
    saveNextContactAt() {
      this.savingContact = true;

      this.$api.records.setNextContactAt(this.record.id, {'next_contact_at': this.nextContactValue })
        .then((res) => {
          const message = (this.isCreateNextContactAt)
            ? 'Task for the Next Contact At was created'
            : 'Next Contact At has been saved'

          this.$buefy.toast.open({
            message: message,
            type: 'is-success'
          });

          if (this.status.state === ENUMS.StatusStateEnum.FollowUp.value) {
            this.$store.dispatch('followUpState/setup');
          }
        })
        .finally(() => {
          this.savingContact = false;
        });
    },
    cancelNextContactAt() {
      this.nextContactValue = this.record.next_contact_at;
    }
  },
};
</script>

<style lang="scss" scoped>

::v-deep .form_field .field.has-addons {
  flex-wrap: nowrap !important;
}
</style>
